export const BREAKPOINTS = {
  md: 768,
} as const;

export const PRIORITY_ELECTRIC_COLORS = {
  high: "#D92d3f",
  medium: "#FFA500",
  low: "#7b8fc9",
} as const;

export const BOARD_ELECTRIC_COLOR = "#D93025";

export const PRIORITY_VALUES = ["low", "medium", "high"] as const;

export const STORE_KEY = "devboard-store";
